import { Component, Input, OnInit } from '@angular/core';
import { Zone, PendingTypes } from '@interfaces/rest/interfaces/zone';
import { ModalController } from '@ionic/angular';
import { AlertConfirmComponent } from '../alert-confirm/alert-confirm.component';

@Component({
  selector: 'app-config-pendings',
  templateUrl: './config-pendings.component.html',
  styleUrls: ['./config-pendings.component.scss'],
})
export class ConfigPendingsComponent implements OnInit {
  @Input() zones: Zone[] = [];
  @Input() pendings: PendingTypes = {
    normal: [],
    reserve: [],
    priority: [],
    special: []
  };
  types = {
    normal: true,
    reserve: false,
    priority: false,
    special: false
  };
  searchFilters = {
    normal: '',
    reserve: '',
    priority: '',
    special: ''
  };
  copiedZoneIds: string[] = [];
  constructor(private modalController: ModalController) { }

  ngOnInit() {
    // Aplicar ordenación inicial a las zonas
    this.sortZones();
  }

  private sortZonesComparator(a: Zone, b: Zone): number {
    // Zones with valid order field always come first
    const aHasOrder = a.order !== undefined && a.order !== null && a.order !== 0;
    const bHasOrder = b.order !== undefined && b.order !== null && b.order !== 0;

    if (aHasOrder && !bHasOrder) {
      return -1; // a comes first
    }
    if (!aHasOrder && bHasOrder) {
      return 1; // b comes first
    }

    // Both have valid order field - sort by order value
    if (aHasOrder && bHasOrder) {
      // If same order value, sort by numeric name
      if (a.order === b.order) {
        const aMatch = a.name?.match(/^\d+/);
        const bMatch = b.name?.match(/^\d+/);
        if (aMatch && bMatch) {
          return parseInt(aMatch[0]) - parseInt(bMatch[0]);
        }
        return (a.name || '').localeCompare(b.name || '');
      }
      return a.order! - b.order!;
    }

    // Both don't have order field - sort by numeric name or alphabetically
    const aMatch = a.name?.match(/^\d+/);
    const bMatch = b.name?.match(/^\d+/);

    if (aMatch && bMatch) {
      return parseInt(aMatch[0]) - parseInt(bMatch[0]);
    }

    // Fall back to string comparison if no numbers
    return (a.name || '').localeCompare(b.name || '');
  }

  private sortZones() {
    this.zones = this.zones.sort((a, b) => this.sortZonesComparator(a, b));
  }

  getFilteredZones(type: keyof PendingTypes): Zone[] {
    const searchTerm = this.searchFilters[type].toLowerCase().trim();
    let filteredZones = this.zones;

    if (searchTerm) {
      filteredZones = this.zones.filter(zone =>
        zone.name?.toLowerCase().includes(searchTerm)
      );
    }

    // Asegurar que siempre estén ordenadas
    return [...filteredZones].sort((a, b) => this.sortZonesComparator(a, b));
  }

  dismiss() {
    this.modalController.dismiss();
  }

  togglePending(zoneId: string, type: keyof PendingTypes) {
    if (this.pendings[type].includes(zoneId)) {
      this.pendings[type] = this.pendings[type].filter(id => id !== zoneId);
    } else {
      this.pendings[type].push(zoneId);
    }
    console.log('this.pendings', this.pendings);
  }

  toggleType(type: keyof PendingTypes) {
    this.types[type] = !this.types[type];
  }

  savePendings() {
    this.modalController.dismiss({ pendings: this.pendings });
  }

  copyPendings(type: keyof PendingTypes, event: Event) {
    event.stopPropagation();
    // Copiar los IDs de las zonas que están marcadas (checked) en este tipo
    this.copiedZoneIds = [...this.pendings[type]];
  }

  pastePendings(type: keyof PendingTypes, event: Event) {
    event.stopPropagation();
    if (this.copiedZoneIds.length === 0) {
      return;
    }
    // Buscar los IDs copiados en el listado de zonas y marcarlos
    const zonesToMark = this.zones
      .filter(zone => this.copiedZoneIds.includes(zone._id))
      .map(zone => zone._id);

    // Agregar los IDs encontrados al tipo actual (sin duplicados)
    zonesToMark.forEach(zoneId => {
      if (!this.pendings[type].includes(zoneId)) {
        this.pendings[type].push(zoneId);
      }
    });
  }

  async clearPendings(type: keyof PendingTypes, event: Event) {
    event.stopPropagation();

    // Mostrar confirmación antes de eliminar
    const modal = await this.modalController.create({
      component: AlertConfirmComponent,
      cssClass: 'confirm',
      componentProps: {
        message: '¿Estás seguro de que quieres desmarcar todas las zonas de este tipo?',
        icon: 'dp-alert'
      }
    });

    await modal.present();
    const result = await modal.onWillDismiss();

    if (result.data) {
      // Si el usuario confirma, limpiar todos los checks del tipo
      this.pendings[type] = [];
    }
  }
}
